var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVipGiftHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "url(#paint0_linear_1187_42234)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0307 15.6672C29.3677 15.6672 29.6615 15.6262 29.912 15.5442C30.1626 15.4577 30.3698 15.337 30.5338 15.1821C30.7023 15.0227 30.8276 14.8314 30.9095 14.6082C30.9915 14.3805 31.0325 14.1277 31.0325 13.8498C31.0325 13.5857 30.9915 13.3465 30.9095 13.1325C30.8276 12.9184 30.7046 12.7362 30.5406 12.5859C30.3766 12.4356 30.1694 12.3217 29.9189 12.2443C29.6684 12.1623 29.3723 12.1213 29.0307 12.1213H27.6574V15.6672H29.0307ZM29.0307 10.7002C29.6911 10.7002 30.2628 10.7776 30.7456 10.9325C31.2284 11.0874 31.6269 11.3037 31.9412 11.5815C32.2555 11.8594 32.4878 12.1919 32.6381 12.5791C32.793 12.9662 32.8704 13.3898 32.8704 13.8498C32.8704 14.3281 32.7907 14.7676 32.6313 15.1685C32.4718 15.5647 32.2327 15.9063 31.9139 16.1933C31.595 16.4802 31.1942 16.7034 30.7114 16.8628C30.2332 17.0223 29.6729 17.102 29.0307 17.102H27.6574V20.5796H25.8196V10.7002H29.0307Z",
    fill: "url(#paint8_linear_1187_42234)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6076 20.5796H21.7629V10.7002H23.6076V20.5796Z",
    fill: "url(#paint9_linear_1187_42234)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7403 10.7002L16.7503 20.5796H15.0901L11.1001 10.7002H12.5759C12.7353 10.7002 12.8651 10.7389 12.9653 10.8163C13.0655 10.8938 13.1406 10.994 13.1908 11.117L15.5205 17.143C15.598 17.3388 15.6708 17.5552 15.7392 17.792C15.812 18.0243 15.8804 18.268 15.9441 18.5231C15.9988 18.268 16.058 18.0243 16.1218 17.792C16.1855 17.5552 16.2561 17.3388 16.3336 17.143L18.6497 11.117C18.6861 11.0122 18.7567 10.9165 18.8615 10.83C18.9708 10.7435 19.1029 10.7002 19.2577 10.7002H20.7403Z",
    fill: "url(#paint10_linear_1187_42234)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1187_42234",
    x1: 45.5,
    y1: 38,
    x2: -3.00042,
    y2: 7.50067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#726051"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1187_42234",
    x1: 33.1001,
    y1: 20,
    x2: 11.2,
    y2: 18.1572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3B186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1187_42234",
    x1: 33.1001,
    y1: 20,
    x2: 11.2,
    y2: 18.1572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3B186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1187_42234",
    x1: 33.1001,
    y1: 20,
    x2: 11.2,
    y2: 18.1572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3B186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEE4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipGiftHistory);
export default __webpack_public_path__ + "static/media/vip-gift-history.efb63921ec3f4ede472ba6c5aeb7436a.svg";
export { ForwardRef as ReactComponent };